import React, { useState, useEffect, useRef } from 'react';
import { useApp } from '../../context/AppContext';
import './PhotosEntreprise.css';

export default function PhotosEntreprise() {
  const { data } = useApp();
  const photos  = data.photosEntreprise || [];
  const [idx, setIdx]     = useState(0);
  const [paused, setPaused] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (photos.length <= 1 || paused) return;
    timerRef.current = setInterval(() => setIdx(i => (i + 1) % photos.length), 4500);
    return () => clearInterval(timerRef.current);
  }, [photos.length, paused]);

  if (photos.length === 0) return null;

  const prev = () => { clearInterval(timerRef.current); setIdx(i => (i - 1 + photos.length) % photos.length); };
  const next = () => { clearInterval(timerRef.current); setIdx(i => (i + 1) % photos.length); };

  const cur = photos[idx] || {};

  return (
    <section className="pe-section" id="galerie" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
      {/* Background image */}
      <div className="pe-bg" style={{ backgroundImage: `url(${cur.data})` }} />
      <div className="pe-overlay" />

      {/* Content */}
      <div className="pe-content">
        <div className="pe-header">
          <div className="pe-tag">📸 Notre Entreprise</div>
          <h2 className="pe-title">KOTOSTECHNOLOGY en Images</h2>
        </div>

        {/* Main photo */}
        <div className="pe-main">
          <button className="pe-arrow pe-prev" onClick={prev}>‹</button>

          <div className="pe-frame">
            <img src={cur.data} alt={cur.caption || 'Photo entreprise'} className="pe-photo" />
            <div className="pe-info">
              <div className="pe-counter">{idx + 1} / {photos.length}</div>
              {cur.caption && <div className="pe-caption">{cur.caption}</div>}
              {cur.categorie && <div className="pe-cat">{cur.categorie}</div>}
            </div>
            {/* Progress bar */}
            {!paused && photos.length > 1 && (
              <div className="pe-progress">
                <div className="pe-progress-bar" key={idx} />
              </div>
            )}
          </div>

          <button className="pe-arrow pe-next" onClick={next}>›</button>
        </div>

        {/* Thumbnails strip */}
        {photos.length > 1 && (
          <div className="pe-thumbs">
            {photos.map((p, i) => (
              <div
                key={i}
                className={'pe-thumb' + (i === idx ? ' active' : '')}
                onClick={() => { clearInterval(timerRef.current); setIdx(i); }}
              >
                <img src={p.data} alt="" />
              </div>
            ))}
          </div>
        )}

      </div>
    </section>
  );
}
